import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Profile({ onLogout }) {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [realname, setRealname] = useState('');
  const [feishuWebhook, setFeishuWebhook] = useState('');
  const [message, setMessage] = useState('');

  // 修改密码
  const [showPwdModal, setShowPwdModal] = useState(false);
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [pwdLoading, setPwdLoading] = useState(false);

  const token = localStorage.getItem('notes_token');

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await fetch(`${API_URL}/api/user/profile`, {
        headers: { 'x-token': token }
      });
      const data = await res.json();
      if (data.success) {
        setProfile(data);
        setRealname(data.realname);
        setFeishuWebhook(data.feishu_webhook || '');
      } else {
        setMessage(data.error || '获取信息失败');
      }
    } catch (e) {
      setMessage('网络错误');
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/user/profile`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify({ realname, feishu_webhook: feishuWebhook })
      });
      const data = await res.json();
      if (data.success) {
        setProfile({ ...profile, realname, feishu_webhook: feishuWebhook });
        setEditing(false);
        setMessage('保存成功');
        setTimeout(() => setMessage(''), 2000);
      } else {
        setMessage(data.error || '保存失败');
      }
    } catch (e) {
      setMessage('网络错误');
    }
    setLoading(false);
  };

  const handleChangePwd = async () => {
    if (!oldPwd || !newPwd || !confirmPwd) return setMessage('请填写完整信息');
    if (newPwd !== confirmPwd) return setMessage('两次密码不一致');
    if (newPwd.length < 4) return setMessage('密码至少4个字符');
    setPwdLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/user/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify({ oldPassword: oldPwd, newPassword: newPwd })
      });
      const data = await res.json();
      if (data.success) {
        setShowPwdModal(false);
        setOldPwd(''); setNewPwd(''); setConfirmPwd('');
        setMessage('密码修改成功');
        setTimeout(() => setMessage(''), 2000);
      } else {
        setMessage(data.error || '修改失败');
      }
    } catch (e) {
      setMessage('网络错误');
    }
    setPwdLoading(false);
  };

  if (loading) return <div className="loading">加载中...</div>;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <button onClick={() => navigate('/')} className="btn-back">← 返回</button>
        <h2>个人中心</h2>
        <button onClick={onLogout} className="btn-logout-small">退出</button>
      </div>

      {message && <p className="profile-message">{message}</p>}

      <div className="profile-card">
        <div className="profile-item">
          <label>账号</label>
          <span>{profile?.username}</span>
        </div>

        <div className="profile-item">
          <label>姓名</label>
          {editing ? (
            <input
              type="text"
              value={realname}
              onChange={e => setRealname(e.target.value)}
              className="profile-input"
            />
          ) : (
            <span>{profile?.realname || '未设置'}</span>
          )}
        </div>

        <div className="profile-item">
          <label>注册时间</label>
          <span>{profile?.created_at ? new Date(profile.created_at).toLocaleDateString('zh-CN') : '-'}</span>
        </div>

        <div className="profile-item webhook-item">
          <label>飞书Webhook</label>
          {editing ? (
            <input
              type="text"
              placeholder="用于接收通知"
              value={feishuWebhook}
              onChange={e => setFeishuWebhook(e.target.value)}
              className="profile-input"
            />
          ) : (
            <span className="webhook-value">{feishuWebhook || '未设置'}</span>
          )}
        </div>

        <div className="profile-actions">
          {editing ? (
            <>
              <button onClick={handleSave} className="btn-primary">保存</button>
              <button onClick={() => { setEditing(false); setRealname(profile?.realname); setFeishuWebhook(profile?.feishu_webhook); }} className="btn-secondary">取消</button>
            </>
          ) : (
            <>
              <button onClick={() => setEditing(true)} className="btn-primary">编辑信息</button>
              <button onClick={() => setShowPwdModal(true)} className="btn-secondary">修改密码</button>
            </>
          )}
        </div>
      </div>

      {/* 修改密码弹窗 */}
      {showPwdModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>修改密码</h3>
            <input
              type="password"
              placeholder="旧密码"
              value={oldPwd}
              onChange={e => setOldPwd(e.target.value)}
              className="login-input"
            />
            <input
              type="password"
              placeholder="新密码（至少4位）"
              value={newPwd}
              onChange={e => setNewPwd(e.target.value)}
              className="login-input"
            />
            <input
              type="password"
              placeholder="确认新密码"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
              className="login-input"
            />
            {message && <p className="modal-message">{message}</p>}
            <div className="modal-actions">
              <button onClick={handleChangePwd} disabled={pwdLoading} className="btn-primary">
                {pwdLoading ? '修改中...' : '确定'}
              </button>
              <button onClick={() => { setShowPwdModal(false); setMessage(''); }} className="btn-secondary">取消</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
